<template>
    <div v-if="Store.Checkout.Cart.SelectedService == 'Apostille'" style="margin-bottom:20px;">
        <div class="row text-start">
            <div class="col-lg-4 checkout-content" style="min-height:250px; padding-left:30px;padding-top:10px;" :style="{'background-image': 'url(' + Store.Checkout.BackgroundImage + ')'}">
                <div class="text-start text-muted fw-bold small"><i class="bi-cart-check" style="color:black;"></i> Your Order:</div>
                <h5 style="color:black;margin-left:15px;">
                    Apostille Service
                </h5>

                <div class="text-center">
                    <img src="/images/apostilleicon.png" style="width:50%;max-width:100px;margin-top:10px;" />
                </div>
            </div>
            <div class="col-lg-8 p-0">

                <div class="position-relative text-center px-3" style="top:5px;">

                    <div class="h3 text-muted fw-semibold text-capitalize">Texas Apostille Service</div>
                    <!-- Input Card -->
                    <div class="fw-bold p-0 mb-1" style="color:limegreen">&nbsp; Apostille Services Are Processed Via Mail</div>

                    <label class="small shadow-sm" style="margin-top:5px;font-size:14px;color:darkgray;border:1px solid lightgray;padding:3px;"><i class="bi-info-circle"></i>&nbsp;You will receive the mailing address to which you must send your documents, along with complete instructions, via email after your order is processed.</label>

                    <!-- End Input Card -->
                    <hr />
                    <div v-if="ApostilleConfigQualifiers && ApostilleConfigQualifiers.length">
                        <div class="mt-3 mb-3 text-center fw-bold" style="color:limegreen">
                            Please Agree To The Following Statements Before Continuing
                        </div>
                        <div>
                            <ul class="list-group list-group-flush">
                                <li v-for="(q, idx) in ApostilleConfigQualifiers" class="highlight-hover list-group-item justify-content-between align-items-start">
                                    <div class="form-check form-switch text-start">
                                        <input style="width: 2rem;height:1rem;position:relative;top:7px;" :value="true" v-model="ApostilleQualifierAnswers[idx]" class="form-check-input" type="checkbox" role="switch" :id="'flexSwitchCheckDefault'+idx">
                                        <label class="form-check-label text-start" style="font-size: 12px; font-weight: bold;vertical-align:top" :for="'flexSwitchCheckDefault'+idx">{{q}}</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row text-center">
            <div class="col-12">

            </div>
        </div>
    </div>
</template>

<script>
    import { useEditorStore } from '/src/stores/EditorStore';
    import EventHub from '/src/Util/EventHub.js';
    import axios from '/src/components/NovaAxios.js';
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';

    export default {
        name: 'VenueSelectFieldNotary',
        components: {
        },
        watch: {
            AnsweredAllQualifiers: {
                handler: function (newVal) {
                    if (!this.Store || !this.Store.Checkout || !this.Store.Checkout.NextButton) {
                        return;
                    }
                    this.Store.Checkout.NextButton.IsVisible = newVal;
                },
                immediate: true
            },
            ApostilleConfigQualifiers: {
                handler: function (newVal) {
                    const qualifiers = Array.isArray(newVal) ? newVal : [];
                    this.ApostilleQualifierAnswers = qualifiers.map(() => false);

                    if (!this.Store || !this.Store.Checkout || !this.Store.Checkout.NextButton) {
                        return;
                    }

                    if (!qualifiers.length) {
                        this.Store.Checkout.NextButton.IsVisible = true;
                    }
                },
                immediate: true
            },
        },
        props: {
        },
        data() {
            const store = useEditorStore();
            return {
                Store: store,
                ApostilleQualifierAnswers: [],
                
            };
        },
        methods:
        {
            // wizcmd next is "requestnextstep"
            OnCmdNext: async function () {
                if(this.Store.Checkout.Cart.CurrentStep != 1){
                    return;
                }
                
                if (this.Store.Checkout.Cart.SelectedService == "Apostille") {
                    this.StartError = ''; 
                    const qualifiers = this.ApostilleConfigQualifiers;
                    if (qualifiers && qualifiers.length) {
                        var allTrue = this.ApostilleQualifierAnswers.every(function (element) { return element == true; });
                        if (!allTrue) {
                            toast.error("Please confirm all of the document questions before continuing.");
                            return;
                        }
                    }

                    this.Store.SetCurrentStep((this.Store.Checkout.Cart.CurrentStep || 0) + 1)
                }
            }
        },
        computed:
        {
            AnsweredAllQualifiers: function () {
                if (!this.ApostilleQualifierAnswers.length) {
                    return true;
                }

                var allTrue = this.ApostilleQualifierAnswers.every(function (element) { return element == true; });
                return allTrue;
            },
            ApostilleConfigQualifiers: function () {
                return this.ApostilleConfig.qualifiers || [];
            },

            ApostilleConfig: function () {
                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigApostille) {
                    return this.Store.TenantConfig.serviceConfigApostille;
                }

                return {};
            },
        },
        beforeMount: function () {

        },
        created: function () {
            // Store already initialized in data; this keeps compatibility if lifecycle re-evaluates.
            this.Store = this.Store || useEditorStore();
        },
        mounted: function () {
            if (this.Store.Checkout.Cart.SelectedService == "Apostille") {

                this.Store.Checkout.NextButton.Text = "Continue To Scheduling";
                this.Store.Checkout.NextButton.Icon = "bi-calendar-check";

                const qualifiers = this.ApostilleConfigQualifiers;
                this.ApostilleQualifierAnswers = qualifiers.map(() => false);
                if (!qualifiers.length && this.Store?.Checkout?.NextButton) {
                    this.Store.Checkout.NextButton.IsVisible = true;
                }
            }
                        
            EventHub.$on('OnCmdNext', this.OnCmdNext);
        },
        beforeUnmount: function () {
            EventHub.$off('OnCmdNext', this.OnCmdNext);
           
        }
    }
</script>

<style>
  
</style>
